import * as React from 'react';
import { Outlet, useMatch } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { hasJWTInfo } from '../../../model/JWT/methods';
import { navigateForEffect } from '../../../model/routing';
import { useIsRightMenu } from '../../../helper/hooks/useIsrightMenu';
import { RightMen } from '../../../GRID/components/RightMenu';
import '../../../styles.module.scss';
import { addressesSign } from '../../../addresses/sign';

export function WorkContainerContent() {
  const matchers = useMatch(`${addressesSign.signPath}/*`);
  const [isStopRender, setStopRender] = useState(true);

  useEffect(() => {
    const pathnameRaw =
      typeof window !== 'undefined' ? window.location.pathname : '';
    const pathname = (() => {
      if (pathnameRaw !== '/' && pathnameRaw.endsWith('/')) {
        return pathnameRaw.slice(0, -1);
      }
      return pathnameRaw;
    })();
    const isOnSign = pathname === addressesSign.signPath;
    if (!hasJWTInfo() && matchers === null && !isOnSign) {
      navigateForEffect(addressesSign.signPath, { replace: true });
      setStopRender(true);
    } else if (!hasJWTInfo() && matchers === null && isOnSign) {
      setStopRender(true);
    } else {
      setStopRender(false);
    }
  }, [matchers]);

  const isRightMenu = useIsRightMenu();
  if (isStopRender) {
    return null;
  }
  return (
    <>
      <Outlet />
      {isRightMenu && <RightMen />}
    </>
  );
}
